import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"

export default function GenerateStudents({images, jobKeys, level, unitCount, title}) {
    return function(stage) {
        let steps = []

        jobKeys = stage.random.shuffle(jobKeys)

        const affiliation = "bad"

        const existingEnemyUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == affiliation
        })

        const encounterKeys = [1]
        encounterKeys.forEach((encounterKey, index) => {
            const spots = stage.random.shuffle(Object.values(stage.world.spots).filter((spot) => {
                return Geometry.isInBounds(stage.encounters[encounterKey], spot.position)
                    && spot.tag == "badspawn"
            }))

            if(spots.length == 0) return

            for(let i = existingEnemyUnits.length; i < unitCount; i += 1) {
                const spot = spots[i]
                if(spot == undefined) return

                const jobKey = jobKeys.shift()
                jobKeys.push(jobKey)
                steps.push(Step.deltastage({
                    "unit": {
                        "title": title || "???",
                        "subtitle": "Student",
                        "affiliation": affiliation,
                        "key": stage.random.key(),

                        "jobKey": jobKey,
                        "image": images[jobKey],
                        "level": level,
                        "maxhealth": 20 + (level * 10),
                        "power": 10 + (level * 10),
                        "position": {
                            "x": spot.position.x,
                            "y": spot.position.y,
                            "z": spot.position.z,
                        },
                    }
                }))
            }
        })

        return steps
    }
}
